import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessPolicyService } from '../services/access-policy.service';

export const manageUsersGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  const router = inject(Router);

  return accessPolicy.canManageUsers()
    ? true
    : router.createUrlTree(['/organization/settings']);
};
